import { Container } from "@mantine/core";
import clsx from "clsx";
import React from "react";
import classes from "./page-section.module.css";

export type PageSectionVariant = "light" | "dark" | "gray" | "darkBottom";

interface PageSectionProps {
  variant: PageSectionVariant;
  id?: string;
  /** Use for hero-style padding (6rem top, 5rem bottom). Default false. */
  firstSection?: boolean;
  /** Apply min-height 90vh. Default true. */
  minHeight?: boolean;
  children: React.ReactNode;
  /** Container size. Default "xl". */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  /** Optional class for the inner Container. */
  containerClassName?: string;
}

export default function PageSection({
  variant,
  id,
  firstSection = false,
  minHeight = true,
  children,
  size = "xl",
  className,
  containerClassName,
}: PageSectionProps) {
  return (
    <section
      id={id}
      className={clsx(classes.section, className)}
      data-variant={variant}
      data-first-section={firstSection ? "true" : undefined}
      data-min-height={minHeight ? "true" : undefined}
    >
      <Container size={size} className={containerClassName}>
        {children}
      </Container>
    </section>
  );
}
